<template>
    <div class="salesInvoice">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目部：">
                                <el-select v-model="dataForm.projectDeptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="欠款单位：">
                                <el-input v-model="dataForm.debtName" placeholder="请输入欠款单位" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <div v-if="showAdvanceFilter">
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="发票抬头：">
                                    <el-input v-model="dataForm.billHead" placeholder="请输入发票抬头" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="100px" label="纳税人识别号：">
                                    <el-input v-model="dataForm.billTaxNumber" placeholder="请输入纳税人识别号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="申请日期：">
                                    <el-date-picker
                                            @change="approveTimeChange"
                                            v-model="dataForm.approveTime"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            :default-time="['00:00:00', '23:59:59']">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="税率：">
                                    <el-input v-model="dataForm.taxRatio" placeholder="请输入税率" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="100px" label="录入发票号码：">
                                    <el-input v-model="dataForm.billNumber" placeholder="请输入录入发票号码" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="100px"  label="不含税金额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.notTaxPriceMin" placeholder="请输入最小税额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.notTaxPriceMax" placeholder="请输入最大税额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="税额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.taxPriceMin" placeholder="请输入最小税额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.taxPriceMax" placeholder="请输入最大税额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="发票金额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.priceMin" placeholder="请输入最小税额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.priceMax" placeholder="请输入最大税额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>

                            <el-col :span="6">
                                <el-form-item label-width="80px" label="审批状态：">
                                    <el-select v-model="dataForm.receiptsStatus" placeholder="请选择审批状态">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="待收款" :value="0"></el-option>
                                        <el-option label="已收款" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </div>
                        <el-col :span="showAdvanceFilter?6:6" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                                <el-button type="text" @click="moreScreen">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.approve.btnEnable"
                                    type="primary"
                                    icon="el-icon-check"
                                    @click="goToInputConfirm()"
                            >确认收款</el-button>
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportHandle()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="invoiceList"
                        highlight-current-row
                        @selection-change="handleSelectionChange"
                        @row-click="rowClicked"
                        @cell-dblclick="dblclickDetail"
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                    <el-table-column
                            prop="approveCode"
                            label="申请编号"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="projectDeptName"
                            label="项目部"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="debtName"
                            label="欠款单位"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billHead"
                            label="发票抬头"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billTaxNumber"
                            width="100"
                            label="纳税人识别号"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="notTaxPrice"
                            width="120"
                            label="不含税金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="100"
                            prop="taxPrice"
                            label="税额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="100"
                            prop="taxRatio"
                            label="税率（%）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120"
                            prop="price"
                            label="发票金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="approveStatusDisplayName"
                            label="审批状态"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="approveUserName"
                            label="申请人"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="approveTime"
                            label="申请日期"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billNumber"
                            width="120"
                            label="录入发票号码"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billPrice"
                            width="120"
                            label="录入发票金额"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="receiptsStatusDisplayName"
                            label="收款状态"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="receiptsPrice"
                            label="收款金额"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="receiptsTime"
                            label="收款时间"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="receiptsRemark"
                            label="收款备注"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import {
        getReceiptsListService,
        getDeptListService,
        getProjectListService,
        receiptsExportService,
    } from '@/services/invoiceServices'
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "inputInvoice",
        data(){
            return {
                dataForm:{
                    projectDeptId: '',
                    projectId: '',
                    debtName: '',
                    billHead: '',
                    billTaxNumber: '',
                    approveTime: '',
                    approveStartTime:'',
                    approveEndTime:'',
                    notTaxPriceMin:'',
                    notTaxPriceMax:'',
                    taxPriceMax:'',
                    taxPriceMin:'',
                    taxRatio:'',
                    priceMin:'',
                    priceMax:'',
                    billPrice:'',
                    receiptsStatus:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                total:0,
                showAdvanceFilter: false,
                deptList:[], //项目部列表
                projectList:[], //项目列表
                invoiceList:[], //表格数据列表
                selectItems:[], //选中的列表
                btnAuthorize: {
                    approve: { key: "approve", btnEnable: false },
                    export: { key: "export", btnEnable: false }
                },
            }
        },
        props: {
            menuCode: {
                type: String
            }
        },
        methods:{
            onActive(menuCode) {
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getInvoiceList();
                this.getDeptList();
            },
            //根据条件查询
            query(){
                this.getInvoiceList();
            },
            reset(){
                this.dataForm = {
                    projectDeptId: '',
                    projectId: '',
                    debtName: '',
                    billHead: '',
                    billTaxNumber: '',
                    approveTime: '',
                    approveStartTime:'',
                    approveEndTime:'',
                    notTaxPriceMin:'',
                    notTaxPriceMax:'',
                    taxPriceMax:'',
                    taxPriceMin:'',
                    taxRatio:'',
                    priceMin:'',
                    priceMax:'',
                    billPrice:'',
                    receiptsStatus:'',
                    pageIndex: 1,
                    pageSize: 10,
                };
                this.projectList = [];
                this.getInvoiceList();
            },
            /**
             * 获取列表数据
             * */
            getInvoiceList(){
                let paramsData = {
                    ...this.dataForm
                }
                getReceiptsListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.invoiceList = res.data;
                        this.total = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.projectDeptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            moreScreen() {
                this.showAdvanceFilter = !this.showAdvanceFilter;
                // if (this.showAdvanceFilter) {
                //     this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
                // } else {
                //     this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
                // }
            },
            //去收款确认页面
            goToInputConfirm(){
                if (this.selectItems.length === 1) {
                    if(this.selectItems[0].receiptsStatusDisplayName == '已收款'){
                        this.$alert("该发票已收款", "提示", {
                            confirmButtonText: "确定"
                        });
                        return
                    }
                    this.bus.$emit("navMenuChange", {
                        routeId: "inputConfirm",
                        routeParam: {
                            approveId: this.selectItems[0].approveId,
                            outputBillId: this.selectItems[0].id,
                        }
                    });
                } else {
                    this.$alert("请选择一条发票信息", "提示", {
                        confirmButtonText: "确定"
                    });
                }

            },
            approveTimeChange(val){
                if(val){
                    this.dataForm.approveStartTime = this.dataForm.approveTime[0];
                    this.dataForm.approveEndTime = this.dataForm.approveTime[1];
                }else{
                    this.dataForm.approveStartTime = '';
                    this.dataForm.approveEndTime = '';
                }
            },
            // 列代表多选回调
            handleSelectionChange(val) {
                this.selectItems = val;
            },
            // 点击选中行
            rowClicked(row, event, column) {
                this.$refs.dataTable.toggleRowSelection(row);
            },
            dblclickDetail(row, column, cell, event) {
                console.log(row)
                this.bus.$emit("navMenuChange", {
                    routeId: "inputInvoiceDetail",
                    routeParam: {
                        outputBillId: row.id
                    }
                });
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getInvoiceList();
            },

            /**
             * 导出
             * */
            exportHandle(){
                let params = {
                    ...this.dataForm,
                    pageSize: 10000,
                }
                receiptsExportService(params).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .salesInvoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    /deep/.el-form-item__content{
        height: 40px;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
        .btnList{
            text-align: right;
        }
        /deep/.el-form-item__content{
            height: auto;
        }
    }
    .fixStyle{
        display: flex;
        align-items: center;
        .lineBox{
            margin: 0 10px;
        }
    }
</style>
